import { reactive, ref } from 'vue'
import { useQuery } from 'vue-query'

import { fetchMembersSearch } from './vueQuery/search-remote-members'

import { UserFullInfo } from '@/dto/UserFullInfo'

export const useSearchRemoteMembers = ({ search }, options = {}) => {
  const reactiveSearch = ref(search)

  const queryKey = reactive([
    'members',
    {
      reactiveSearch,
    },
  ])

  const query = useQuery(queryKey, {
    cacheTime: 0,
    retry: 0,
    queryFn: fetchMembersSearch,
    select: ({ data }) => {
      return data.map((houseHolder) => new UserFullInfo(houseHolder))
    },
    ...options,
  })

  return {
    ...query,
  }
}
